module.exports = __webpack_public_path__ + "img/no-data-UEEx.8213535c.png";